var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"d-flex justify-end"},[_c('v-alert',{attrs:{"value":_vm.error,"text":"","color":"main_gray","type":"info","width":"550","dismissible":"","shaped":""},on:{"click":_vm.delete_error}},[_vm._v(_vm._s(_vm.error_text)+" ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }